import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import compose from 'helpers/compose';
import Layout from 'components/Layout';

import AccountComplete from './AccountComplete';
import { RootStore } from 'stores/rootStore';
import { Params } from '../Edit/accountEditRoutes';

interface Props {
  rootStore: RootStore;
}

const AccountCompleteLayout: React.FC<Props> = ({ rootStore }) => {
  const { accountId } = useParams<Params>();
  const { t } = useTranslation();

  useEffect(() => {
    rootStore.stores.editAccountStore.fetchBasicData(accountId);
  }, [rootStore.stores.editAccountStore, accountId]);

  return (
    <Layout
      title={t('pageTitle_accountComplete', {
        accountName: rootStore.stores.editAccountStore.accountName,
      })}
    >
      <AccountComplete />
    </Layout>
  );
};

export default compose(inject('rootStore'), observer)(AccountCompleteLayout);
